import React, { useState } from 'react';
import { Button, Menu, MenuItem, Box } from '@mui/material';

// Reusable Dropdown component
const DropdownMenu = ({ title, items }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={handleClick}
        variant="text"
        style={{ textAlign: 'center', color: '#be1f41', textTransform: 'none' }}
      >
        {title}
      </Button>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {items.map((item, index) => (
          <MenuItem
            key={index}
            onClick={handleClose}
            component="a"
            href={item.href}
            style={{color:'#be1f41'}}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

const NavigationMui = () => {
  return (
    <Box display="flex" gap={2} flexWrap="wrap">
      <DropdownMenu
        title="Account Management"
        items={[
          { label: 'AM Dashboard', href: '/am-dashboard' },
          { label: 'Planned Usage Dashboard', href: '/usage-tracking' },
          { label: 'Weighted Scores', href: '/weighted-scores' },
          { label: 'Quarterly Number Review', href: '/quarterly-number-review' },
          { label: 'Quarterly Numbers Update', href: '/quarterly-numbers' },
          { label: 'Prasco Report', href: '/prasco-report' },
          { label: 'Address Shortener', href: '/address-shortener' },
        ]}
      />
    
      <DropdownMenu
        title="Supply Chain"
        items={[
          { label: "Pam's Dashboard", href: '/pamsdashboard' },
          { label: 'Targeted Report', href: '/targeted-report' },
          { label: 'Target List Availability', href: '/target-list-availability' },
          { label: "Supply Chain Dashboard", href: '/supply-chain-dashboard' },
          { label: 'Ordering Tool', href: '/orderingtool' },
          { label: 'Donor Report', href: '/donorreport' },
          { label: 'Product Creation', href: '/product-creation' },
          { label: 'Donor Receipt', href: '/donor-receipt' },
          { label: 'Insulin Tracker', href: '/insulin-tracker' },
          { label: 'Receiving, Distributing, and P1', href: '/receiving-distributing-p1' },
          { label: 'IQVIA Target List', href: '/target-list' },
          { label: 'Product Data', href: '/product-data' },
          { label: 'Search By Serial', href: '/search-by-serial' },
          { label: 'Last in Stock vs. Last Shipped', href: '/last-stocked-last-shipped' },
          { label: 'Cold Chain Tracker', href: '/cold-chain-product' },
          { label: 'Procurement App', href: 'https://main.d338481l4kn1tf.amplifyapp.com/' },
          { label: 'Montly WAC/Accounting', href: '/monthly-wac-accounting' },
          { label: 'Yearly Donor Receipt', href: '/yearly-donor-receipt' },
        ]}
      />

      <DropdownMenu
        title="Distribution"
        items={[
          { label: 'Tally Web', href: 'https://prod.d2yvjdr9maddnk.amplifyapp.com/' },
          { label: 'Irregular Orders', href: '/irregular-orders' },
          { label: 'DOH Dashboard', href: '/dohdashboard' },
          { label: 'Destruction of Drugs', href: '/destruction-of-drugs' },
          { label: 'Recalled Products', href: '/recalled-products' },
          { label: 'DC Orders Report', href: '/dc-orders' },
        ]}
      />

      <DropdownMenu
        title="Marketing"
        items={[{ label: 'Marketing Dashboard', href: '/marketing-dashboard' }]}
      />

      <DropdownMenu
        title="Pharmacy Services"
        items={[
          { label: 'Disease State Calendar', href: '/disease-state' },
          { label: 'Pharmacy Services', href: '/pharmacy-services' },
          { label: 'Student Project Request Form', href: '/student-project-form' },
        ]}
      />

      <DropdownMenu
        title="IT"
        items={[
          { label: 'IT and Analytics Dashboard', href: '/it-analytics' },
          { label: 'IT Request Form', href: '/it-request' },
          { label: 'Allocation Changes', href: '/allocation' },
        ]}
      />

      <DropdownMenu
        title="Network Expansion"
        items={[
          { label: 'Customer Dashboard', href: '/networkexpansion' },
          { label: 'Overview Dashboard', href: '/ne-overview-dashboard' },
          { label: 'Optum Tool Dashboard', href: '/optum-tool' },
        ]}
      />

      <Button href="/charitable-formulary" style={{ textTransform: 'none', color: '#be1f41' }}>
        Charitable Formulary
      </Button>
    </Box>
  );
};

export default NavigationMui;
